const SmorderActions = Object.freeze({
  Proceed: 0,
  ProceedChildOrder: 1,
  Order: 2,
  Storno: 3,
  Reject: 4,
  Feedback: 5,
  Close: 6,
  OrderWithPaymentWebhook: 7,
  Reschedule: 8,
  ReassignUser: 9,
  AllChildOrdersDone: 10,
  SetExpectedDeliveryTime: 11,
  SplitChildOrder: 12,
  ExternalOrder: 13,
  PrintReceipt: 14,
  PrintInvoice: 15,
  Undo: 28,
});

export default SmorderActions;
